import script from "./OpdBillAnalysisTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OpdBillAnalysisTable.vue?vue&type=script&setup=true&lang=js"

import "./OpdBillAnalysisTable.vue?vue&type=style&index=0&id=598a4916&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598a4916"]])

export default __exports__